"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguage = void 0;
const languageCodes_1 = require("root/src/shared/constants/languageCodes");
const getLanguageCode_1 = require("root/src/shared/util/getLanguageCode");
const router_1 = require("next/router");
const cookies_1 = require("root/src/client/v2/browser/helpers/cookies");
const domainName_1 = __importDefault(require("root/src/aws/util/domainName"));
const useLanguage = () => {
    const router = (0, router_1.useRouter)();
    const languageSwitchHandler = (languageCode) => {
        const { protocol } = new URL(window.location.href);
        (0, cookies_1.setCookie)('languageCode', languageCode);
        if (languageCode === languageCodes_1.languageCodes.en) {
            return router.push(`${protocol}//${domainName_1.default}${router.asPath}`);
        }
        return router.push(`${protocol}//${languageCode}.${domainName_1.default}${router.asPath}`);
    };
    const languageCode = useLanguageCode();
    return {
        languageCode,
        languageSwitchHandler,
    };
};
exports.useLanguage = useLanguage;
const useLanguageCode = () => {
    if (typeof window === 'undefined') {
        return languageCodes_1.languageCodes.en;
    }
    return (0, getLanguageCode_1.getLanguageCodeFromHost)(window.location.host);
};
